export default __webpack_public_path__ + "static/media/casino.fc105057.png";